import {NgModule} from '@angular/core';
import {SearchInvoiceComponent} from './search-invoice/search-invoice.component';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {InvoiceComponent} from './invoice.component';
import {ComponentsModule} from '../../../components/components.module';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ToastModule} from 'primeng/toast';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {SelectModule} from 'primeng/select';
import {CheckboxModule} from 'primeng/checkbox';
import {PanelModule} from 'primeng/panel';
import {DatePickerModule} from 'primeng/datepicker';
import {MultiSelectModule} from 'primeng/multiselect';
import {InputNumberModule} from 'primeng/inputnumber';
import {ButtonModule} from 'primeng/button';
import {MessageModule} from 'primeng/message';
import {TooltipModule} from 'primeng/tooltip';
import {AccordionModule} from 'primeng/accordion';
import {
    ProductRemunerationSelectorComponent
} from './product-remuneration-selector/product-remuneration-selector.component';
import {RemunerationAccordionComponent} from './remuneration-accordion/remuneration-accordion.component';
import {Ripple} from "primeng/ripple";
import {ExcelPreviewComponent} from './excel-preview/excel-preview.component';
import {SplitButtonModule} from 'primeng/splitbutton';
import {InvoicePeriodPickerComponent} from './search-invoice/invoice-period-picker.component';

const cmp = [SearchInvoiceComponent, InvoiceComponent,
    ProductRemunerationSelectorComponent, RemunerationAccordionComponent, ExcelPreviewComponent, InvoicePeriodPickerComponent];
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ComponentsModule,
        TableModule,
        ConfirmDialogModule,
        DialogModule,
        RouterModule,
        InputTextModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        ToastModule,
        PanelModule,
        DatePickerModule,
        MultiSelectModule,
        InputNumberModule,
        MessageModule,
        TooltipModule,
        ButtonModule,
        SplitButtonModule,
        AccordionModule,
        Ripple
    ],
    declarations: [...cmp],
    exports: [
        ...cmp,

    ]
})
export class InvoiceModule {
}
